import { render, staticRenderFns } from "./StaffSearch.vue?vue&type=template&id=bf5a5386"
import script from "./StaffSearch.vue?vue&type=script&lang=js"
export * from "./StaffSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports